export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13968.60bbf5cc.jpg";